<template lang="html">
   <div class="nav-side">
      <div class="header clearfix">
         <div class="brand">
            <img src="/img/logo.png" alt="" class="logo">
         </div>
         <div class="navTrigger active" @click="toggleNav()">
            <i></i><i></i><i></i>
         </div>
      </div>
      <div class="menu-content">
         <div class="heading">
            <span class="text">
               MAIN
            </span>
            <span class="dot"></span>
         </div>
         <div>
            
         </div>
         <div v-for="route in routes" :key="route.name || route.component">
            <div v-if="route.children">
               <div 
                  :id="`menu-${route.id}`" 
                  class="menu-item clearfix" 
                  :class="{'active' : getChildren(route.children).includes($route.name)}" 
                  @click="toggleCollapse(route.id)"
               >
                  <div :class="route.icon || 'fa fa-columns'"></div>
                  <div class="menu-text">{{route.name || route.component}}</div>
                  <div class="fa fa-chevron-down"></div>
               </div>
               <div :id="route.id" class="collapse collapse-box">
                  <router-link v-for="r in route.children" :key="r.name || route.component" :to="{name: r.component}">
                     <div class="menu-item clearfix">
                        <div class="fa fa-circle fa-outline"></div>
                        <div class="menu-text" :class="{'active': $route.name === r.component}">{{r.name || r.component}}</div>
                     </div>
                  </router-link>
               </div>
            </div>
            <router-link :to="{name: route.component}" v-else>
               <div class="menu-item clearfix" :class="{'active': $route.name === route.component}">
                  <div :class="route.icon || 'fa fa-columns'"></div>
                  <div class="menu-text">{{route.name || route.component}}</div>
               </div>
            </router-link>
         </div>
         </div>
      </div>
   </div>
</template>

<script>
   export default {
      data () {
         return {
            routes:[
               { icon: 'fa fa-columns',component: 'Dashboard'},
               {
                  icon: 'fa fa-boxes', name: 'Reports', children: [
                     { component: 'Transactions_By_Date', name: 'Transaction By Date'},
                     { component: 'Transactions_By_ID', name: 'Transaction By Ref'},
                     { component: 'Promo_Codes', name: 'Promo Codes'},
                     { component: 'Customers_Registered', name: 'Customers Registered'},
                  ], id: 'reports'
               },
               {
                  icon: 'fa fa-sliders-h', name: 'Configs', children: [
                     { component: 'Pump_Attendants', name: 'Pump Attendants'},
                     { component: 'Fuel_Stations', name: 'Fuel Stations'},
                     { component: 'Admin_Users', name: 'Admin Users'},
                     { component: 'Payment_Options', name: 'Payment Options'},
                  ], id: 'configs'
               },
            ]
         }
      },
      methods: {
         toggleNav () {
            this.$el.querySelector('.navTrigger').classList.toggle('active')
            document.querySelector('.layout-sidenav').classList.toggle('icons-only')
            document.querySelector('.nav-side').classList.toggle('show-mobile')
         },
         toggleCollapse(id){
            this.$el.querySelector(`#menu-${id}`).classList.toggle('collapsed')
            this.$el.querySelector(`#${id}`).classList.toggle('show')
         },
         getChildren(children){
            return children.map(e => {return e.component})
         }
      },
   }
</script>

<style lang="scss">
/* width */
</style>